import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getDatabase, ref, onValue } from 'firebase/database';
import './AdmissionManagement.css';

const AdmissionManagement = () => {
  const [students, setStudents] = useState([]);

  useEffect(() => {
    const db = getDatabase();
    const usersRef = ref(db, 'users');

    const unsubscribe = onValue(usersRef, (snapshot) => {
      const users = snapshot.val();
      if (users) {
        const studentList = Object.keys(users)
          .filter(uid => users[uid].role === 'student' && users[uid].status === 'enrolled')
          .map(uid => ({ uid, ...users[uid] }));
        setStudents(studentList);
      } else {
        setStudents([]);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="admission-management-container">
      <h2>Admission Management</h2>
      <p>Select a student to view their admission letter.</p>
      <div className="student-list">
        {students.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Class</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {students.map(student => (
                <tr key={student.uid}>
                  <td>{student.name}</td>
                  <td>{student.class || 'Not Assigned'}</td>
                  <td>
                    <Link to={`/admission-letter/${student.regNo}`} className="btn" target="_blank" rel="noopener noreferrer">View Letter</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No enrolled students found.</p>
        )}
      </div>
    </div>
  );
};

export default AdmissionManagement;
